var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.166,
    height: 22.707,
    viewBox: "0 0 18.166 22.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "signout-svgrepo-com",
    d: "M18.76,2H7.406A3.345,3.345,0,0,0,4,5.406v6.812h9.764L11.153,9.607a1.124,1.124,0,0,1,1.59-1.59l4.541,4.541a1.1,1.1,0,0,1,0,1.59h0L12.742,18.69a1.124,1.124,0,0,1-1.59-1.59l2.611-2.611H4V21.3a3.345,3.345,0,0,0,3.406,3.406H18.76A3.345,3.345,0,0,0,22.166,21.3V5.406A3.345,3.345,0,0,0,18.76,2Z",
    transform: "translate(-4 -2)",
    fill: "#d5ad67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.47e74f7c0f6149487d54f5db4376f766.svg";
export { ForwardRef as ReactComponent };